import { useQuery } from '@tanstack/react-query';

import { useOrgAndPrograms } from '@/hooks/useOrgAndPrograms';
import { faxService } from '@/services/fax.service';

/**
 * Hook to fetch faxes for a case record
 */
export const useFaxes = (caseRecordId: string | null) => {
  const { selectedOrganizationId, selectedProgramId } = useOrgAndPrograms();

  return useQuery({
    queryKey: ['faxes', selectedOrganizationId, selectedProgramId, caseRecordId],
    queryFn: async () => {
      if (!selectedOrganizationId || !selectedProgramId || !caseRecordId) {
        throw new Error('Missing required parameters');
      }

      return faxService.getFaxes({
        organizationId: selectedOrganizationId,
        programId: selectedProgramId,
        caseRecordId,
      });
    },
    enabled: !!selectedOrganizationId && !!selectedProgramId && !!caseRecordId,
    staleTime: 30000, // Consider data fresh for 30 seconds
  });
};
